import React from "react";
import "./FeaturedSales.css";
import { FaBed, FaBath } from "react-icons/fa";
import { MdSquareFoot } from "react-icons/md";
import Bedroom from "../Images/bedroom1.jpg";
import { useNavigate } from "react-router-dom";

const FeaturedSales = () => {
  const properties = [
    { id: 1, img: Bedroom },
    { id: 2, img: Bedroom },
    { id: 3, img:Bedroom },
    { id: 4, img: Bedroom }
  ];
  const navigate = useNavigate();

  return (
    <div className="featured-sales-container">
      <div className="featured-sales-header">
        <h2>Featured Rental</h2>
        <button className="featured-filter-btn" onClick={()=>navigate("/search-results")}>All</button>
      </div>

      <div className="featured-sales-grid">
        {properties.map((item) => (
          <div className="featured-card" key={item.id} onClick={()=>navigate("/rental-details")}>
            <img src={item.img} alt="property" className="featured-image" />

            <div className="featured-card-body">
              <h3 className="featured-price">₹290.00</h3>
              <p className="featured-title">Apartment for rent</p>
              <p className="featured-location">London, Oxford St.</p>
              <p className="featured-date">26 November 2020</p>

              <div className="featured-icons">
                <span>
                  <FaBed /> 3+1
                </span>

                <span>
                  <FaBath /> 10
                </span>

                <span>
                  <MdSquareFoot /> 150 m²
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedSales;